import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class StockComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) {
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

       // Debounce search.
    this.productSearchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.SearchTerm = value;

        if(this.SearchTerm?.length > 2){
          this.SearchIndustryProducts();
        }
      });

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.Filter.SearchTerm = value;

        if(this.Filter.SearchTerm?.length > 2){
          this.Filter.Pager.PageIndex = 1;
          this.GetIndustryProductsStocksFiltered(this.Filter.Pager.PageIndex);
        }
      });

        // Debounce search.
     this.partnerSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.Filter.SearchTerm = value;
          this.GetPartnersFiltered();
        }
      });

       // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFiltered(value);
        }
      });

         // Debounce search.
     this.warehouseSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetWarehousesFiltered(value);
        }
      });
   }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  brandSearchTermUpdate = new Subject<string>();
  warehouseSearchTermUpdate = new Subject<string>();
  partnerSearchTermUpdate = new Subject<string>();
  productSearchTermUpdate = new Subject<string>();

  SearchTerm:string;

  //for gallery objetcs
  StockProducts:any[];
  SearchedProducts:any[];

  Filter: {[k: string]: any} = {};
  Totals: any[];
  activeFilters:{[k: string]: any} = [];
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  
  Periods:any[];
  Updaters:any[];
  FilterLoading:boolean;
  Companies:{[k: string]: any} = [];
  CurrentStock:{[k: string]: any} = {};
  Currencies:{[k: string]: any} = [];

  ProductBoxStatuses:{[k: string]: any} = [];
  ProductConditionStatuses:{[k: string]: any} = [];
  ProductManufacturingStatuses:{[k: string]: any} = [];
  ProductVersionStatuses:{[k: string]: any} = [];
  Countries:{[k: string]: any} = [];
  WeightMeasurementTypes:{[k: string]: any} = [];
  LeadTimeTypes:{[k: string]: any} = [];
  ExportIndustryProductsStockValuesTypes:{[k: string]: any} = [];
  ExportIndustryProductsStockValuesType:any;
  CombineWarehousesQuantityOnExport:boolean = true;

  ExportOnlyUIData:boolean = false;

  Languages:{[k: string]: any} = [];
  ExportLanguage:any;

  ShowFilter:boolean;

  ngOnInit(): void {
    this.InitializeFilter();
    this.GetIndustryProductsMasterData();
    this.ShowFilter = false;
  }

  CloseOverlay(){
    this.StockProducts = [];
    this.ShowFilter = false;
    this.SearchTerm = "";
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  GetIndustryProductsMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetIndustryProductsMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.Periods = response["Periods"];
     this.Companies = response["Companies"];
     this.ProductBoxStatuses = response["ProductBoxStatuses"];
     this.ProductConditionStatuses = response["ProductConditionStatuses"];
     this.ProductManufacturingStatuses = response["ProductManufacturingStatuses"];
     this.ProductVersionStatuses = response["ProductVersionStatuses"];
     this.WeightMeasurementTypes = response["WeightMeasurementTypes"];
     this.LeadTimeTypes = response["LeadTimeTypes"];
     this.Currencies = response["Currencies"];
     this.ExportIndustryProductsStockValuesTypes = response["ExportIndustryProductsStockValuesTypes"];
     this.ExportIndustryProductsStockValuesType = this.ExportIndustryProductsStockValuesTypes[0];
     this.Languages = response["Languages"];
     this.ExportLanguage = this.Languages[0];

     this.Countries = response["Countries"];
    }
 
    this.parent.loading = false;

    this.GetIndustryProductsStocksFiltered(1);
   });
   }
  
  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Period = {};
    this.Filter.Period = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.Warehouse = {};
    this.Filter.Warehouse = null;

    this.Filter.ProductBoxStatus = {};
    this.Filter.ProductBoxStatus = null;

    this.Filter.ProductConditionStatus = {};
    this.Filter.ProductConditionStatus = null;

    this.Filter.ProductManufacturingStatus = {};
    this.Filter.ProductManufacturingStatus = null;

    this.Filter.ProductVersionStatus = {};
    this.Filter.ProductVersionStatus = null;

  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "ProductBoxStatus"){
      this.Filter.ProductBoxStatus = null;
    }
    else if(filterType == "ProductConditionStatus"){
      this.Filter.ProductConditionStatus = null;
    }
    else if(filterType == "ProductManufacturingStatus"){
      this.Filter.ProductManufacturingStatus = null;
    }
    else if(filterType == "ProductVersionStatus"){
      this.Filter.ProductVersionStatus = null;
    }

    this.Filter.Pager.PageIndex = 1;
    this.GetIndustryProductsStocksFiltered(this.Filter.Pager.PageIndex);
  }
  
  GetIndustryProductsStocksFiltered(page = 1){
    this.Filter.Pager.PageIndex = page;  
    
    var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.Filter
      };

      this.parent.loading = true;

      this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.StockProducts = response["StockProducts"];
        }

        this.parent.loading = false;
       });

       this.GetIndustryProductsStocksFilteredCOUNT();
  }

  GetIndustryProductsStocksFilteredCOUNT(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    this.parent.loading = true;

    this.managementService.GetIndustryProductsStocksFilteredCOUNT(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];
      }

      this.parent.loading = false;

     });
}


  Brands:any[];
  FilterBrandName:string;

  ClearSearchBrand(){

    this.Filter.Brand = null;
    this.Brands = [];
    this.FilterBrandName = null;
    this.Filter.Pager.PageIndex = 1;
    this.GetIndustryProductsStocksFiltered();
   }

   GetBrandsFiltered(searchTerm:string){
    
    var BrandFilter = {
      SearchTerm:searchTerm,
      Pager:this.Filter.Pager,
      Company:this.parent.Company
    };
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
    
         if(this.Brands.length == 1){
          this.Filter.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
          this.FilterBrandName = this.Filter.Brand.Name;
          this.Brands = [];
          this.Filter.Pager.PageIndex = 1;
          this.GetIndustryProductsStocksFiltered();
         }
        }
       });
   }

   Warehouses:any[];
   FilterWarehouseName:string;

   GetWarehousesFiltered(searchTerm:string){
    var WHFilter = {
      SearchTerm:searchTerm,
      Pager:this.Filter.Pager,
      Company:this.parent.Company
    };
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:WHFilter
      };

      this.service.GetWarehousesFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Warehouses = response["Warehouses"];
    
         if(this.Warehouses.length == 1){
          this.Filter.Warehouse = JSON.parse(JSON.stringify(this.Warehouses[0]));
          this.FilterWarehouseName = this.Filter.Warehouse.Name;
          this.Warehouses = [];
          this.Filter.Pager.PageIndex = 1;
          this.GetIndustryProductsStocksFiltered();
         }
        }
       });
   }

   ClearSearchWarehouse(){
    this.Filter.Warehouse = null;
    this.Warehouses = [];
    this.FilterWarehouseName = null;
    this.Filter.Pager.PageIndex = 1;
    this.GetIndustryProductsStocksFiltered();
    this.ConfigurationWarehouseName = "";
   }

   ClearSearchWarehousePop(){
    this.ConfigurationWarehouseName = "";

    this.Configuration =  null;
    this.ListPriceOffer.Configuration = this.Configuration;
    this.ConfigurationWarehouseName = this.Configuration.Warehouse?.Name;
    this.NewProduct[0].ListPriceOffer = JSON.parse(JSON.stringify(this.ListPriceOffer));
   }

   InitializeBrands(){
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("");
    }
  }

  InitializeWarehouses(){
    if(this.Warehouses == null || this.Warehouses.length == 0){
      this.GetWarehousesFiltered("");
    }
  }

  ShowNewStockEntryContainer:boolean;
  NewProduct:any;
  ListPriceOffer:any;
  ListPriceOfferPartnerName:string;
  ConfigurationWarehouseName:string;
  Partners:any[];
  Configuration:any;

  InitializeNewStockEntry(entry:any = null, CopyProduct:boolean = false){
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        CopyProduct:CopyProduct,
        Product:entry
      };

      this.managementService.InitializeNewStockEntry(request).subscribe(response => {
 
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.ListPriceOffer = JSON.parse(JSON.stringify(response["Product"].ListPriceOffers[0]));
          this.Configuration = this.ListPriceOffer.Configuration;
          this.ConfigurationWarehouseName = this.Configuration.Warehouse?.Name;
          this.ShowNewStockEntryContainer = true;
        }
       });
  }

  CloseDashMenu(){
    this.ShowNewStockEntryContainer = false;
  }

  ClearPartnerBrand(){

    if(this.ListPriceOffer != null){
      this.ListPriceOffer.Partner = {};
    }

    this.Filter.Partner = null;
    this.Partners = [];
    this.ListPriceOfferPartnerName = "";
   }

   InitializePartners(){
    if(this.Partners == null || this.Partners.length == 0){
      this.Filter.Pager.PageIndex = 1;
      this.Filter.SearchTerm = "";
      this.GetPartnersFiltered();
    }
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.Filter.SearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID
    };

    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.Filter.Pager.TotalCount = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }

  GetWarehouse(id:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      WarehouseID:id
    };
  
    this.service.GetWarehouse(request).subscribe(response => {
  
      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Configuration.Warehouse =  response["Warehouse"];
      }
     });
   }

   GetImportConfigurationByWarehouse(id:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      WarehouseID:id
    };
  
    this.managementService.GetImportConfigurationByWarehouse(request).subscribe(response => {
  
      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Configuration =  response["Configuration"];
        this.ListPriceOffer.Configuration = this.Configuration;
        this.ConfigurationWarehouseName = this.Configuration.Warehouse?.Name;
        this.NewProduct[0].ListPriceOffer = this.ListPriceOffer;
      }
     });
   }

   InitializeSearchProduct(){
    if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
      this.SearchIndustryProducts();
    }
  }

  SearchIndustryProducts(){
    
    var filter = JSON.parse(JSON.stringify(this.Filter));
    filter.SearchTerm = this.SearchTerm;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:filter
    };
  
    this.parent.loading = true;
  
    this.managementService.SearchIndustryProducts(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SearchedProducts = response["SearchResults"];
      }
  
      this.parent.loading = false;
     });
  }

  GetIndustryProductByID(ID:number, withOffers:boolean){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:ID,
      WithListPriceOffers:withOffers
    };
  
    this.parent.loading = true;
  
    this.managementService.GetIndustryProductByID(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var p = response["Product"];
        this.NewProduct = p;
        this.NewProduct.ListPriceOffers = [];
        this.ListPriceOffer.ParentID = JSON.parse(JSON.stringify(this.NewProduct.ID));
        this.NewProduct.ListPriceOffers.push(JSON.parse(JSON.stringify(this.ListPriceOffer)));

        this.SearchedProducts = [];
        this.SearchTerm = "";
      }
  
      this.parent.loading = false;
     });
  }

  ClearSearchIndustryProducts(){
    this.SearchTerm = "";
    this.SearchedProducts = [];
  }

  AddUpdateListPriceOffer(offer:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Offer:offer
    };
  
    this.parent.loading = true;
  
    this.managementService.AddUpdateListPriceOffer(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowNewStockEntryContainer = false;

        if(offer.ID > 0){
          this.GetIndustryProductsStocksFiltered(this.Filter.Pager.PageIndex);
        }
        else{
          this.GetIndustryProductsStocksFiltered(1);
        }
      }
  
      this.parent.loading = false;
     });
  }

  ShowDeleteProductQuestion:boolean;

  PrepareDeleteListPriceOffer(p:any){
    this.ListPriceOffer = p.ListPriceOffers[0];
  }

  DeleteIndustryProductStockOffer(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      OfferID:this.ListPriceOffer.ID
    };
  
    this.parent.loading = true;
  
    this.managementService.DeleteIndustryProductStockOffer(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetIndustryProductsStocksFiltered(1);
      }
  
      this.parent.loading = false;
     });
  }

  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }

  ExportIndustryProductsStockValues(){
  
      var request = {
        User:this.parent.User,
        Language:this.ExportLanguage?.Name,
        Filter:this.Filter,
        ExportType:this.ExportIndustryProductsStockValuesType,
        CombineWarehousesQuantityOnExport:this.CombineWarehousesQuantityOnExport,
        ExportOnlyUIData:this.ExportOnlyUIData
      };
     
      this.parent.loading = true;
  
      this.managementService.ExportIndustryProductsStockValues(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          var Document = response["Document"];
          this.download(Document.Name, Document.PDFStream);
        }
     
        this.parent.loading = false;
      });
  }

  ShowExportStockQuestion:boolean;
}
